import request from '@/utils/request'

// 盲底列表
export function blindList(query) {
  return request({
    url: '/v1.0/iwrs/blind/all',
    method: 'get',
    params: query
  })
}

// 上传盲底
export function uploadBlind(data) {
  return request({
    url: '/v1.0/iwrs/blind/upload',
    method: 'post',
    data,
    headers: {'Content-Type': 'multipart/form-data;charset=UTF-8'}
  })
}

// 下载
export function downFile(query) {
  return request({
    url: '/v1.0/iwrs/blind/down/template',
    method: 'get',
    params: query
  })
}

// 生成盲低
export function generate(data) {
  return request({
    url: '/v1.0/iwrs/blind/generate',
    method: 'post',
    data
  })
}

// 获取生成盲底结果
export function generateResult(data) {
  return request({
    url: '/v1.0/iwrs/blind/generate_result',
    method: 'get',
    params: data
  })
}

// 使用
export function apply(data) {
  return request({
    url: '/v1.0/iwrs/blind/apply',
    method: 'post',
    data
  })
}

// 详情
export function detail(query) {
  return request({
    url: '/v1.0/iwrs/blind/detail',
    method: 'get',
    params: query
  })
}

// 获取分区列表，编辑的时候调用来获取所有分区
export function get_section_list(query) {
  return request({
    url: '/v1.0/iwrs/blind/get/section_list',
    method: 'get',
    params: query
  })
}

// 追加盲底
export function append(data) {
  return request({
    url: '/v1.0/iwrs/blind/append',
    method: 'post',
    data
  })
}

// 删除
export function deleteBlind(data) {
  return request({
    url: '/v1.0/iwrs/blind/delete',
    method: 'delete',
    data
  })
}

// 更新盲底
export function updateBlind(data) {
  return request({
    url: '/v1.0/iwrs/blind/update',
    method: 'put',
    data
  })
}

// 下载模板
export function downTemplate(query) {
  return request({
    url: '/v1.0/iwrs/blind/down/template',
    method: 'get',
    params: query
  })
}
